import { AxInit, ModuleName } from '../../Lib/AxSystem/AxInit';

@ModuleName("AxPixelTracking")
export class AxPixelTracking implements AxInit {
    private initData: initData;
    private fbq;

    AxInit(init: initData) {
        this.initData = init;
        this.initData.action && typeof this[this.initData.action] != 'undefined' && this[this.initData.action]();
        this.fbq = typeof window?.fbq != 'undefined' ? window.fbq : () => undefined;
    }

    addToCart() {
        AxessViewer.loadPartialView('/PixelTracking/PixelAddItemToCartResult', {}, (resp) => {
            this.fbq('track', 'AddToCart', resp);
        }, { silent: true });
    }

    removeFromCart() {
        if (typeof this.initData.positionId == 'undefined' || this.initData.positionId == '') {
            return;
        }
        const data = { targetPositionId: this.initData.positionId };
        AxessViewer.loadPartialView('/PixelTracking/PixelRemoveItemFromCartResult', data, (resp) => {
            this.fbq('track', 'RemoveFromCart', resp);
        }, { silent: true });
    }

    initiateCheckout() {
        AxessViewer.loadPartialView('/PixelTracking/PixelAddPaymentInfoResult', {}, (resp) => {
            this.fbq('track', 'InitiateCheckout', resp);
        }, { silent: true });
    }

    purchase() {
        const data = { orderNr: this.initData.orderNr };
        AxessViewer.loadPartialView('/PixelTracking/Purchase', data, (resp) => {
            this.fbq('track', 'Purchase', resp);
        }, { silent: true });
    }

    completeRegistration() {
        if (typeof this.initData.status == 'undefined') {
            return;
        }
        const data = { status: this.initData.status };
        AxessViewer.loadPartialView('/PixelTracking/Register', data, (resp) => {
            this.fbq('track', 'CompleteRegistration', resp);
        }, { silent: true });
    }
}

interface initData {
    action: string | undefined;
    orderNr?: string;
    positionId?: string;
    status?: boolean;
}

declare global {
    export interface Window {
        fbq?: {
            (command: string, action: string, data: any): void;
        };
    }
}